import { baseRestApi, createTag } from '@src/utils/rtkQuery';

export type AdjustedSettlementDateResponse = {
  Offset: string;
  numericOffset: number; // 1, 2, etc.
  AdjustedDate: string;
};

/**
 * RTK Query endpoints for fetching adjusted settlement dates.
 *
 * - Primarily consumed by `AdjustedSettlementDatesProvider` which queries next settlement dates for given date (today by default)
 * - The settlement dates are then made available via React context (`useAdjustedSettlementDates` hook)
 */
const adjustedSettlementDateEndpoints = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    getAdjustedSettlementDates: builder.query<AdjustedSettlementDateResponse[], { settlementDate: string }>({
      query: ({ settlementDate }) => ({
        method: 'GET',
        url: `/adjusted-settlement-date/${settlementDate}?offsetLimit=2`,
      }),
      providesTags: (_result, _error, { settlementDate }) => [createTag('AdjustedSettlementDate', settlementDate)],
      transformResponse: (response: AdjustedSettlementDateResponse[]) => {
        return response.map(r => ({
          ...r,
          numericOffset: parseInt(r.Offset),
        }));
      },
    }),
  }),
});

export const { useGetAdjustedSettlementDatesQuery } = adjustedSettlementDateEndpoints;
